import ShareBundle from "@/components/ShareBundle";
import useTranslation from "@/hooks/useTranslation";
import { message, Popconfirm } from "antd";
import copy from "copy-to-clipboard";
import QRCode from "qrcode.react";
import React from "react";
import styles from "./styles.module.less";

const { btn } = styles;

interface IProps {
  children: JSX.Element;
  title?: string;
  url?: string;
}

const SharePop: React.FC<IProps> = (props) => {
  const {
    children,
    title = document.title,
    url = window.location.href,
  } = props;
  const { t } = useTranslation("common");

  return (
    <Popconfirm
      title={<ShareBundle title={title} url={url} />}
      icon={null}
      cancelText={t("share.url")}
      onCancel={() => {
        copy(url);
        message.success(t("share.url-success"));
      }}
      okText={t("share.qrcode")}
      onConfirm={() =>
        // @ts-ignore
        message.open({ content: <QRCode value={url} />, duration: 3 })
      }
    >
      <span className={btn}>{children}</span>
    </Popconfirm>
  );
};

export default SharePop;
